import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { DrillPageContextValue } from "#drill-page-context-value";

export const DrillPageContext = createContext(
  defaultError<DrillPageContextValue>("DrillPageContext"),
);
